/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Thumbnail_Move_ConfirmInputs */



/**
* | output |
* | --- |
* | "Move" |
*
* @param {Explorer_Thumbnail_Move_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_thumbnail_move_confirm = /** @type {((inputs?: Explorer_Thumbnail_Move_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Thumbnail_Move_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Deplacer")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bewegen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Mossa")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Двигаться")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mover")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("移动")
	if (locale === "ja") return /** @type {LocalizedString} */ ("動く")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कदम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mover")
	return /** @type {LocalizedString} */ ("Move")
});